/**
 * Imports Zilla globally;
 *
 * To see performance related stuff of this file, see PRs:
 * - https://github.com/quero-edu/qb-render/pull/2409
 * - https://github.com/quero-edu/qb-render/pull/2542
 */

import Vue from 'vue'
import Zilla from '@quero/zilla-vue'

Vue.use(Zilla)
